var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pz-id bg-dark"},[_c('Spinner',{attrs:{"displayType":"fixed","text":_vm.loadingMessage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }